import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'delete-all-matching-translation-exclusions' as const;

const argumentZod = z.object({
  kind: z
    .enum(['page-field', 'collection-field', 'component-prop'])
    .describe(
      'Which kind of translation exclusion rules to delete -- every rule of this kind for the site is deleted.'
    ),
});

export const deleteAllMatchingTranslationExclusionsManifest =
  defineToolRegistryManifest({
    id: toolName,
    prettyName: 'Delete all matching translation exclusion rules',
    prettyStatus: {
      executing: 'Deleting translation exclusions…',
      executed: 'Deleted translation exclusions',
      failed: 'Deleting translation exclusions failed',
    },
    family: 'localization',
    llmTool: {
      name: toolName,
      description:
        'Permanently deletes every translation exclusion rule of a given kind for the current site, re-enabling translation for everything it covered. Use delete-translation-exclusions instead to target specific rules by id.',
      inputSchema: argumentZod,
    },
    type: 'server',
    requiredScopes: ['sites:write'],
    permission: [{resource: 'Site', action: 'update'}],
    confirmBeforeExecuting: true,
  });

export type DeleteAllMatchingTranslationExclusionsArgumentType = z.infer<
  typeof argumentZod
>;
